import { apiFetch } from "./config.js";
/** The signed-in user's conversations kept on the server, newest first. */
export async function listLookupChats() {
    return apiFetch("/regulation/chats");
}
/** Saves one conversation (a save older than the one kept is ignored by the server). */
export async function saveLookupChat(chat) {
    return apiFetch(`/regulation/chats/${encodeURIComponent(chat.id)}`, {
        method: "PUT",
        body: { title: chat.title, updatedAt: chat.updatedAt, messages: chat.messages },
    });
}
/** Uploads the conversations a browser kept; returns the user's whole list from the server afterwards. */
export async function importLookupChats(chats) {
    return apiFetch("/regulation/chats/import", { method: "POST", body: { conversations: chats } });
}
export async function deleteLookupChat(id) {
    await apiFetch(`/regulation/chats/${encodeURIComponent(id)}`, { method: "DELETE" });
}
export async function clearLookupChats() {
    await apiFetch("/regulation/chats", { method: "DELETE" });
}
